// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"NavigationItems_NavigationItems__2YZH7","active":"NavigationItems_active__3znNZ"};